import { MODE_KEY, TRANSPORT } from '../utils';

export function TransportCell({ mode }) {
  const key = MODE_KEY[mode] || 'reefer';
  const { Icon, bg, text } = TRANSPORT[key] || TRANSPORT.reefer;
  return (
    <span className={`inline-flex items-center justify-center w-6 h-6 rounded ${bg} ${text}`}>
      <Icon size={13} strokeWidth={1.75} />
    </span>
  );
}
